export function capitalizeCharAndAddSpace(word : string) {
    if (typeof word !== 'string' || word.length === 0) {
      return word; // Return as is if it's not a string or an empty string
    }

    const firstChar = word.charAt(0).toUpperCase();
    let formattedWord = firstChar;

    for (let i = 1; i < word.length; i++) {
      const char = word.charAt(i);

      if (char === char.toUpperCase()) {
        if (formattedWord.indexOf(' ') === -1) {
          // Insert a space before the second uppercase character
          formattedWord += ' ';
        }
      }
      formattedWord += char;
    }
    return formattedWord;
  }